module.exports = __webpack_public_path__ + "img/resource-no-data.de28577d.png";